import { useStore } from "zustand/react";
// The ONLY module that imports zustand's React entry (Doc 01 §2.2). Thin
// `useStore` selectors with stable signatures; React/RN both consume them.
export const useStoreValue = (store, selector) => useStore(store, selector);
export const useTrip = (store) => useStore(store, (s) => s.trip);
export const useCanEdit = (store) => useStore(store, (s) => s.canEdit);
export const useViewConfig = (store) => useStore(store, (s) => s.itemsView);
export const useVisibleItems = (store) => useStore(store, (s) => s.visibleItems());
export const useProgress = (store) => useStore(store, (s) => s.progress());
export const useItems = (store) => useStore(store, (s) => s.items());
export const useItem = (store, id) => useStore(store, (s) => s.items().find((i) => i.id === id));
export const useCategories = (store) => useStore(store, (s) => s.categories());
//# sourceMappingURL=hooks.js.map